import * as ReportActions from '../actions/report.actions';
import {RecurringReport} from '../../../reports/models/recurring-report';
import {ReportCode} from '../../../reports/models/report-code';
import { ReportHistory } from '../../../reports/models/report-history';

export interface State {
  recurringReports: RecurringReport[] | null;
  lastModifiedReport: RecurringReport | null;
  reportFileTypes: Map<string, number[]>;
  isCreated: boolean;
  error: any;
  areRecurringReportsLoaded: boolean;
  areRecurringReportsLoading: boolean;
  areReportsHistoryLoading: boolean;
  areReportsHistoryLoaded: boolean;
  reportsHistory: ReportHistory[] | null;
}

export const initialState: State = {
  recurringReports: null,
  lastModifiedReport: null,
  reportFileTypes: new Map<string, number[]>(),
  isCreated: false,
  error: null,
  areRecurringReportsLoaded: false,
  areRecurringReportsLoading: false,
  areReportsHistoryLoading: false,
  areReportsHistoryLoaded: false,
  reportsHistory: null,
};

export function reducer(
  state = initialState,
  action: ReportActions.ReportActionsUnion
): State {
  const reports: RecurringReport[] = Object.assign([], state?.recurringReports);
  switch (action.type) {
    case ReportActions.getRecurringReports.type:
      return {
        ...state,
        error: null,
        areRecurringReportsLoading: true,
        areRecurringReportsLoaded: false
      };
    case ReportActions.getRecurringReportsSuccess.type:
      return {
        ...state,
        recurringReports: action.recurringReports,
        error: null,
        areRecurringReportsLoading: false,
        areRecurringReportsLoaded: true
      };
    case ReportActions.getRecurringReportsFailure.type:
      return {
        ...state,
        recurringReports: null,
        error: action.error,
        areRecurringReportsLoading: false,
        areRecurringReportsLoaded: false
      };
    case ReportActions.createRecurringReport.type:
      return {
        ...state,
        isCreated: false,
        error: null
      };
    case ReportActions.createRecurringReportSuccess.type:
      reports.push(action.recurringReport);
      return {
        ...state,
        recurringReports: reports,
        isCreated: true,
        error: null
      };
    case ReportActions.createRecurringReportFailure.type:
      return {
        ...state,
        isCreated: false,
        error: action.error
      };
    case ReportActions.deleteRecurringReportSuccess.type:
      const index = reports.findIndex(x => x.id === action.id);
      if (index > -1) {
        reports.splice(index, 1);
      }
      return {
        ...state,
        recurringReports: reports,
        error: null
      };
    case ReportActions.editRecurringReportSuccess.type:
      const i = reports.findIndex(x => x.id === action.oldId);
      if (i > -1) {
        reports[i] = action.recurringReport;
      } else {
        reports.push(action.recurringReport);
      }
      return {
        ...state,
        recurringReports: reports,
        lastModifiedReport: action.recurringReport,
        error: null
      };
    case ReportActions.editRecurringReportFailure.type:
      return {
        ...state,
        lastModifiedReport: null,
        error: action.error
      };
    case ReportActions.getReportFileTypesSuccess.type:
      const map = state.reportFileTypes;
      action['reportsFileTypes'].forEach((x) => {
        map.set(x['id'], x['fileTypes'] as number[]);
      })
      return {
        ...state,
        reportFileTypes: map
      };
    case ReportActions.clearReportFileTypes.type:
      state.reportFileTypes.clear();
      return {
        ...state,
      };
    case ReportActions.getReportsHistory.type:
      return {
        ...state,
        error: null,
        areReportsHistoryLoading: true,
        areReportsHistoryLoaded: false
      };
    case ReportActions.getReportsHistorySuccess.type:
      const reportsHistory = [];
      action?.reports?.forEach(x => reportsHistory.push(new ReportHistory(x)));
      return {
        ...state,
        reportsHistory: reportsHistory,
        areReportsHistoryLoading: false,
        areReportsHistoryLoaded: reportsHistory.length > 0
      };
    case ReportActions.getReportsHistoryFailure.type:
      return {
        ...state,
        error: action.error,
        areReportsHistoryLoading: false,
        areReportsHistoryLoaded: false
      };
    default: {
      return state;
    }
  }
}

export const getRecurringReports = (state: State) => state.recurringReports;
export const getRecurringReportById = (state: State, recurringReportId: number) => state.recurringReports?.find(r => r.id === recurringReportId);
export const getLastModifiedReport = (state: State) => state.lastModifiedReport;
export const getIsCreated = (state: State) => state.isCreated;
export const getReportFileTypes = (state: State, reportGeneratorId: string) => state.reportFileTypes.get(reportGeneratorId);
export const getAllReportFileTypes = (state: State) => state.reportFileTypes;
export const hasError = (state: State) => state.error;
export const getAreRecurringReportsLoaded = (state: State) => state.areRecurringReportsLoaded;
export const getAreRecurringReportsLoading = (state: State) => state.areRecurringReportsLoading;
export const getAreReportsHistoryLoading = (state: State) => state.areReportsHistoryLoading;
export const getAreReportsHistoryLoaded = (state: State) => state.areReportsHistoryLoaded;
export const getReportsHistory = (state: State) => state.reportsHistory;
export const getReportHistoryById = (state: State, reportFileId: number) => state?.reportsHistory?.find(r => r.reportFileId === reportFileId);
